import "@nabble/ui/styles.css";
import { initTheme, installAutoHideScrollbars, installContextMenuGuard, TextFieldMenu } from "@nabble/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// /theme-init.js already applied the saved theme before first paint; this
// only covers environments where that script did not run (tests, previews).
initTheme();
installAutoHideScrollbars();
// No browser right-click menu anywhere: the suite shows its own (in text fields, TextFieldMenu).
installContextMenuGuard();

const container = document.getElementById("root");
if (!container) throw new Error("Missing #root element");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      <TextFieldMenu />
    </BrowserRouter>
  </StrictMode>,
);
